import { Reducer } from 'redux';
import { ADD_NETWORK_DATA, CLEAR_NETWORK_FORM, ADD_NEW_ADDRESS_NETWORK_FORM } from '../../actionTypes';
import { RegisterNetworkData } from 'components/NetworkRegister/NetworkRegisterInterface/NetworkRegisterInterface';
import { RegisterNetworkActions } from '../interface/registerNetworkActionTypes';
import { initialState, emptyAddress } from './initialState';

const networkRegisterReducer: Reducer<RegisterNetworkData, RegisterNetworkActions> = (
  state = initialState,
  action,
): RegisterNetworkData => {
  switch (action.type) {
    case ADD_NETWORK_DATA:
      const updatedDirectors = action.payload.directors
        ? [...state.directors, ...action.payload.directors]
        : [...state.directors];
      // @ts-ignore-next-line
      return { ...state, directors: updatedDirectors, ...action.payload };
    case ADD_NEW_ADDRESS_NETWORK_FORM:
      return {
        ...state,
        directors: state.directors.map((director, index) => {
          if (index === action.payload) {
            director.addresses = [...director.addresses, emptyAddress];
          }
          return director;
        }),
      };
    case CLEAR_NETWORK_FORM:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default networkRegisterReducer;
